import { connect } from 'react-redux';
import { addFutureChanged, changeMetricSelection } from '../actions';
import MetricsPageStep from '../components/MetricsPageStep';
import { getMetricsPageStep } from '../selectors';

const mapStateToProps = state => getMetricsPageStep(state);

const mapDispatchToProps = dispatch => {
    return {
        onChange: (id, value) => dispatch(changeMetricSelection(id, value)),
        enableAddFuture: () => dispatch(addFutureChanged('selectedMetrics', false, true)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(MetricsPageStep);
